module.exports = __webpack_public_path__ + "img/logo-sm-light.7aa02372.png";